(ns frontend.test.search-selector.model)

(def root ::state)
(def root-path [root])

;; root-path for a specific instance of the component.
;; `ident` identifies the specific instance, should be a unique path
;; e.g. [entity-id :oppo/attribute]
(defn i-root-path
  [{:keys [ident] :as _args}]
  (into root-path ident))

(defn extend-path
  [base-path-fn new-key]
  (fn extended-path-fn [args]
    (conj (base-path-fn args) new-key)))

(def query-key :query)
(def query-full-path
  (extend-path i-root-path query-key))

(def query-loading-key :loading?)
(def query-loading-full-path
  (extend-path i-root-path query-loading-key))

;; query used for returned results
(def results-query-key :results-query)
(def results-query-full-path
  (extend-path i-root-path results-query-key))

(def results-by-et-key :results)
(def results-by-et-full-path
  (extend-path i-root-path results-by-et-key))

;; Subscriptions
(def root-state ::state)
(def state ::state-instance)
(def query ::query)
(def results-query ::results-query)
(def query-loading? ::loading?)
(def results-by-et ::results-by-et)

;; Events
(def update-query ::update-query)
(def search ::search)
(def debounced-search ::debounced-search)
(def search-success ::search-success)
(def search-error ::search-error)
